"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurCollectiveMission() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="224161" id="our-brokerage-philosophy" className="bg-background text-foreground py-32 px-4 sm:px-6 lg:px-8 flex items-center justify-center">
      <div ref={ref} className={`max-w-[700px] mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-sm uppercase tracking-widest font-default text-muted-foreground mb-8 sm:mb-10">
          Our Brokerage Philosophy
        </h2>
        <p className="text-2xl sm:text-[28px] leading-relaxed sm:leading-loose font-default text-foreground">BuyMyMSP is an M&amp;A match-maker focused on securing your legacy by connecting IT / MSP owners with <span className="text-primary font-semibold" data-ast-id="f:/src/pages/Home/sections/OurCollectiveMission.tsx|sig:od6244" data-ast-start="1011" data-ast-end="1079">Qualified Buyers</span> at a fraction of the cost. We prioritize transparency and efficiency, ensuring you retain more equity through <span className="text-primary font-semibold" data-ast-id="f:/src/pages/Home/sections/OurCollectiveMission.tsx|sig:od6245" data-ast-start="1220" data-ast-end="1282">Lower Fees</span> while navigating the complexities of MSP valuation and acquisition.</p>
      </div>
    </section>;
}